import React from "react";
import PropTypes from "prop-types";

import GBStartScreenForm from "../Forms/GBStartScreenForm";
import * as GBConst from "../NonComponents/GBConst";
import GBLoginForm from "../../../Library/Forms/GBLoginForm";

class GBAppContentCustom extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        handleLogin: PropTypes.func,
        loginSuccess: PropTypes.func,
        forgotPassword: PropTypes.func,
        createAccount: PropTypes.func,

        onModuleChange: PropTypes.func,

        pageID: PropTypes.string,
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        handleLogin: () => console.log("handleLogin"),
        loginSuccess: () => console.log("loginSuccess"),
        forgotPassword: () => console.log("forgotPassword"),
        createAccount: () => console.log("createAccount"),

        onModuleChange: () => console.log("onModuleChange"),

        pageID: GBConst.GBStartScreenFormPg,
        onPageChange: PropTypes.func,
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderPage = () => {
        let page;

        /* Props */
        const props = this.props;
        const onModuleChange = props.onModuleChange;
        const pageID = props.pageID;

        switch (pageID) {
            case GBConst.GBLoginFormPg:
                page = (
                    <GBLoginForm
                        onPageChange={props.onPageChange}
                        onHandleLogin={props.handleLogin}
                        onLoginSuccess={props.loginSuccess}
                        onHandleForgotPassword={props.forgotPassword}
                        onHandleCreateAccount={props.createAccount}
                        showCreateAccountBtn={false}
                        showForgotPasswordLabel={false}
                    />
                );
                break;

            case GBConst.GBStartScreenFormPg:
                page = <GBStartScreenForm onModuleChange={onModuleChange} />;
                break;

            default:
                page = <div>I DON'T EXIST YET! MY PAGE ID IS "{pageID}"</div>;
                break;
        }

        return page;
    };

    render() {
        try {
            return <div>{this.renderPage()}</div>;
        } catch (exception) {
            return (
                <div
                    className={"GBAppContentCustomDiv"}
                    key={"GBAppContentCustomDiv"}
                >
                    <h3 key={"GBAppContentCustomDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default GBAppContentCustom;
